import { all } from 'redux-saga/effects';
import getCommentsSaga from './watchers/getCommentsSaga';
import addCommentSaga from './watchers/addCommentSaga';

function* competencesSaga() {
  yield all([getCommentsSaga(), addCommentSaga()]);
}

export default competencesSaga;
